<template>
  <BreadCrumb PageTitle="Documentation API" />
  <AccountSettings />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import AccountSettings from "@/components/Generals/DocAPI/ApiDoc.vue";

export default defineComponent({
  name: "AccountSettingsPage",
  components: {
    BreadCrumb,
    AccountSettings,
  },
});
</script>